import { Box, Pagination, Paper, Stack, TextField, Typography } from '@mui/material'
import { DesktopDatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs, { Dayjs } from 'dayjs'
import React, { useEffect, useRef, useState } from 'react'
import { validateDateLimits } from '../manageCoupons/services/services'
import "./OutletMapping.css"
import { Button } from '@mantine/core'
import { ChannelkartNetworkGet, ChannelkartNetworkPut } from '../../services/networkService'
import { GenericTable } from '../../components/genericTable/GenericTable'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { Loader } from '../../components/loader/Loader'
import RenderSvg from '../../components/renderSvg/RenderSvg'
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp'
import { GenericPopUp } from '../../components/popup/genericPopUp'
import { popupType } from '../../types/types'
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider'

export default function OutletMapping() {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const CUR_COMPONENT="Existing Outlet Approval";
    const [rows, setRows] = useState([]);
    const [pages, setPages] = useState(0);
    const [loader, setLoader] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [confirmationPopUp, setConfirmationPopUp] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState<string>("");
    const popUpSuccessMethod = useRef<() => void>();
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [startDate, setStartDate] = React.useState<Dayjs | null>(
        dayjs(new Date())
    );
    const [genericModalState, setGenericModalState] = useState(false);
    const [genericModalMessage, setGenericModalSMessage] = useState("");
    const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

    const setGenericMetaData = (
        message: string,
        type: popupType,
        state: boolean
    ) => {
        setGenericModalState(state);
        setGenericModalSMessage(message);
        setGenericModalType(type);
    };

    const updateStatus = async (
        request:string,modelData: any
    ) => {
        try {
            const reqBody:any={
                entityId:modelData.entityId,
                entityStatus: request === "Approved" ? "approved" : "rejected"
            }
            const response = await ChannelkartNetworkPut(
                `/v1/entityApprovals/${modelData.entityId}/${request}?source=portal&callType=scheduled`,
                reqBody
            );
            if (response.status === 200 || response.status === 201) {
                setGenericMetaData("Successfully updated the data", "Success", true);
            } else {
                setGenericMetaData(
                    "Some error occured while updating the data",
                    "Error",
                    true
                );
            }
        } catch (error) {
              setGenericMetaData(
                "Some Error occured while Updating the Status",
                "Error",
                true
              );
        }
    };

    const updateConfirmationPopData = (
        message: string,
        methodHelper: () => void
    ) => {
        popUpSuccessMethod.current = methodHelper;
        setPopUpMessage(message);
    };

    const exisitingOutletApprovalData: any = {
        actions: [
            "approve", "reject","image"
        ],
        columns: [
            { headerName: "Outlet Code", mappedValue: "outletcode" },
            { headerName: "Outlet Name", mappedValue: "outlet_name" },
            { headerName: "Secondary Code", mappedValue: "secondaryOutletCode" },
            { headerName: "Channel", mappedValue: "channel" },
            { headerName: "Requested By", mappedValue: "requestedUser" },
            { headerName: "Requested Date", mappedValue: "requestDate" },
            { headerName: "Email ID", mappedValue: "email" },
            { headerName: "Contact No", mappedValue: "contactno" },
            { headerName: "Status", mappedValue: "entityStatus" }
        ]
    }
    const [endDate, setEndDate] = React.useState<Dayjs | null>(
        dayjs(new Date())
    );
    const handleStartDate = (newValue: Dayjs | null) => {
        setStartDate(newValue);
    }
    const handleEndDate = (newValue: Dayjs | null) => {
        setEndDate(newValue);
    }
    const getAllEntityMetaData = async (entity: string, page: number) => {
        let url = `/${entity}&size=30&page=${page}&source=portal&callType=scheduled`;
        const response = await ChannelkartNetworkGet(url);
        return response;
    }
    const endPoint = `v1/query/outletEntityApproval?fromDate=${startDate?.format('YYYY-MM-DD')}%2000:00:00&toDate=${endDate?.format('YYYY-MM-DD')}%2023:59:59`;
    const handleApply = async () => {
        try {
            setLoader(true);
            await getTableRows(endPoint, currentPage);
        } catch (error) {
            console.error('Error occurred:', error);
        }
    }
    const getTableRows = async (
        endPoint: string,
        currentPage: number = 1,
    ) => {
        try {
            const response = await getAllEntityMetaData(
                endPoint,
                currentPage - 1
            );
            const rowsWithIdAndParsedUpdateInfo = response?.data?.features.map((row: { updateInfo: any }, index: number) => {
                const parsedUpdateInfo = JSON.parse(row.updateInfo || "{}"); 
                return {
                    ...row,
                    id: index + 1, 
                    updateInfo: parsedUpdateInfo 
                };
            });
            setRows(rowsWithIdAndParsedUpdateInfo);
            setPages(response?.data?.totalPage);
            setLoader(false);
        } catch (error) {
            setRows([]);
            setLoader(false);
        }

    };

    const columns: GridColDef[] = exisitingOutletApprovalData.columns.length
        ? exisitingOutletApprovalData.columns.map((columnsMetaData: any) => {
            return {
                disableColumnMenu: true,
                field: columnsMetaData.mappedValue,
                headerName: translate(TranslationEnum.existing_outlet_approval,columnsMetaData.headerName).toUpperCase(),
                sortable: false,
                minWidth: 100,
                flex: 1,
                headerAlign: "center",
                align: "center",
            };
        })
        : [];

        if (exisitingOutletApprovalData.actions.includes("image")) {
            columns.push({
                field: "Image",
                headerName: translate(TranslationEnum.common_portal,"IMAGE"),
                sortable: false,
                minWidth: 100,
                flex: 1,
                headerAlign: "center",
                align: "center",
                disableColumnMenu: true,
                renderCell: (params: GridRenderCellParams) => {
                    const blobKey = params.row?.updateInfo?.blobKey ?? "";
                    return (
                        blobKey !== "" &&
                        <Button
                            style={{
                                backgroundColor: '#24c6b1',
                                height: "30px",
                                padding: "0 10px"
                            }}
                            onClick={() => {
                                if (blobKey !== "") {
                                    window.open(blobKey, '_blank');
                                }
                            }}
                        >
                            {translate(TranslationEnum.existing_outlet_approval,"View")}
                        </Button>
                    );
                },
            });
        }

    if (exisitingOutletApprovalData.actions.includes("approve")) {
        columns.push({
            field: "Edit",
            headerName: "",
            sortable: false,
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
            disableColumnMenu: true,
            renderCell: (params: GridRenderCellParams) => {
                if (params.row.entityStatus.toLowerCase() === "pending") {
                    return (
                        <div
                            className="edit-button"
                            onClick={() => {
                                setConfirmationPopUp(true);
                                updateConfirmationPopData(
                                    "Are you sure you want to approve the request?",
                                    () => {
                                        updateStatus("Approved", params.row);
                                    }
                                );
                            }}
                        >
                            <Button style={{ backgroundColor: '#24c6b1', height: "30px", padding: "0 10px" }}>{translate(TranslationEnum.common_portal,"Approve")}</Button>
                        </div>
                    );
                } else {
                    return null;
                }
            },
        });
    }

    if (exisitingOutletApprovalData.actions.includes("reject")) {
        columns.push({
            field: "Reject",
            headerName: "",
            sortable: false,
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
            disableColumnMenu: true,
            renderCell: (params: GridRenderCellParams) => {
                if (params.row.entityStatus.toLowerCase() === "pending") {
                    return (
                        <div
                            className="edit-button"
                            onClick={() => {
                                setConfirmationPopUp(true);
                                updateConfirmationPopData(
                                    "Are you sure you want to reject the request?",
                                    () => {
                                        updateStatus("Rejected", params.row);
                                    }
                                );
                            }}
                        >
                            <Button style={{ backgroundColor: '#24c6b1', height: "30px", padding: "0 10px" }}>{translate(TranslationEnum.common_portal,"Reject")}</Button>
                        </div>
                    );
                } else {
                    return null;
                }
            },
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            await getTableRows(endPoint, currentPage);
        };
        fetchData();
    }, []);

    useEffect(() => {
        const res = validateDateLimits(startDate, endDate);
        setErrors(res);
    }, [startDate, endDate]);
    return (
        <Paper className="manageBannerPaperContainer">
            <Box className="manageBannerBoxContainer">
                <Box className="calender-wrapper">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack direction="row" spacing={3} alignItems="center">
                            <DesktopDatePicker
                                 label={translate(TranslationEnum.common_portal,"From Date")}
                                inputFormat="DD/MM/YYYY"
                                value={startDate}
                                onChange={handleStartDate}
                                renderInput={(params) => <TextField {...params} {...(errors['startDate'] && { error: true, helperText: errors['startDate'] })} />}
                            />
                            <DesktopDatePicker
                                 label={translate(TranslationEnum.common_portal,"To Date")}
                                inputFormat="DD/MM/YYYY"
                                value={endDate}
                                onChange={handleEndDate}
                                renderInput={(params) => <TextField {...params} {...(errors['endDate'] && { error: true, helperText: errors['endDate'] })} />}
                            />
                            <Button onClick={handleApply} style={{ backgroundColor: '#24c6b1' }} >{translate(TranslationEnum.common_portal,"APPLY")}</Button>
                        </Stack>
                    </LocalizationProvider>
                </Box>
                <div className="manageBannerBar">
                    <div className="manageBannerBoxHeading">
                        <Typography
                            className="bannerReportHeading"
                            variant="h6"
                            pl={2}
                        >
                            {translate(TranslationEnum.existing_outlet_approval,"Existing Outlet Approval")}
                        </Typography>
                    </div>
                </div>
                <GenericPopUp
                    type={genericModaltype}
                    message={genericModalMessage}
                    openGenericModal={genericModalState}
                    setOpenGenericModal={() => {
                        genericModaltype === 'Success' && getTableRows(endPoint, 1);
                        setGenericModalState(false);
                    }}
                />
                {loader ? (
                    <Loader />
                ) : (
                    <div style={{height:"68%"}} className="table-style">
                        <GenericTable
                            searchedProps={[]}
                            table={{
                                rows,
                                columns,
                                isOfflineSearchEnable: false,
                                hideFooter: true,
                            }}
                        />
                        <div className="pagination">
                            <Pagination
                                count={pages}
                                variant="outlined"
                                shape="rounded"
                                color={"primary"}
                                onChange={async (event, value) => {
                                    setCurrentPage(value);
                                    setLoader(true);
                                    await getTableRows(endPoint, value);
                                }}
                                page={currentPage}
                            />
                        </div>
                    </div>
                )}
                <ConfirmationPopUp
                    openConfirmModal={confirmationPopUp}
                    message={popUpMessage}
                    setOpenConfirmModal={() => {
                        setConfirmationPopUp(false);
                    }}
                    successMethod={popUpSuccessMethod.current}
                />
            </Box>
        </Paper>
    )
}
